/** Shared surface tokens for creator profile metric cards (BuzzBridge dashboard). */
export const CREATOR_METRIC_SURFACE_CONTAINER = '#1a1919';
export const CREATOR_METRIC_SURFACE_LOW = '#131313';
export const CREATOR_METRIC_SURFACE_HI = '#262626';
export const CREATOR_METRIC_SURFACE_VARIANT = '#262626';
export const CREATOR_METRIC_GOLD = '#ffc965';
export const CREATOR_METRIC_MINT = '#00fdc1';
export const CREATOR_METRIC_ON_VARIANT = '#adaaaa';
export const CREATOR_METRIC_OUTLINE = '#767575';
export const CREATOR_METRIC_RADIUS_BTN = '0.75rem';
export const CREATOR_METRIC_RADIUS_CARD = '1.5rem';
export const CREATOR_METRIC_RADIUS_TILE = '1rem';
